import React, { useContext, useState } from "react";
import styled from "styled-components";

import { Button } from "@examspark/common-ui";
import { Resource } from "@examspark/types";

import Canvas from "./Canvas";
import * as Tab from "./common/tabs";
import Context from "./Context";
import { AudioContext } from "./context/AudioContext";
import QuestionContext from "./QuestionContext";

import "./ItemPlayer.css";

const Wrapper = styled.div`
  display: flex;
  background-color: #fff;
  height: 100%;
  flex: 1;
  /* font-size: 1.2em; */

  .choice-drag {
    width: 2.8rem;
    padding-left: 0.5rem;
  }
  .choice-drag > div {
    width: 2.1rem;
    cursor: ns-resize;
    background-image: url("/move-handle-v.png");
    background-size: 11px 24px;
    background-repeat: no-repeat;
    background-position: center 5px;
    opacity: 0.5;
    min-height: 34px;
  }
  .choice-drag > div:hover {
    background-color: #e7e7e7;
    opacity: 1;
  }

  img {
    max-width: 100%;
  }

  blockquote {
    border: solid 2px #000;
    margin: 1rem 0;
    padding: 1rem;

    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }
`;

const Contexts = styled.div`
  max-width: 70rem;
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
  padding: 1rem;
  flex: 1;
`;

const Divider = styled.div`
  width: 5px;
  -webkit-transition: background 0.2s;
  transition: background 0.2s;
  /* cursor: ew-resize; */

  div {
    width: 5px;
    height: 100%;
    background-color: #e7e7e7;
    border-left: solid 1px #ccc;
    border-right: solid 1px #ccc;
    /* background-image: url("/move-handle-slim-v.png"); */
    background-size: 6px 24px;
    background-repeat: no-repeat;
    background-position: center;
    transition: background 0.2s;
    margin: 0 auto;
  }

  /* &:hover div {
    background-image: url("/move-handle-slim-hover-v.png");
    background-color: #ccc;
  } */
`;

const Main = styled.div`
  height: 100%;
  flex: 1.4;
  overflow: auto;
  box-sizing: border-box;
  padding: 1rem;
`;

/**
 * It looks like this is NOT used by exam-ui, but rather used in the cms in key
 * places where a single image is displayed.
 */
const Question = (props: { condensed?: boolean }) => {
  const [state] = useContext(QuestionContext);
  const [shownContextIndex, setShownContextIndex] = useState(0);
  const [showContexts, setShowContexts] = useState(false);

  let contexts: Resource[] = [];
  if (state?.question?.contexts?.items) {
    contexts = [...state.question.contexts.items];
  } else if (state?.question?.contexts) {
    // handle bad type from using @connection
    contexts = [...(state.question?.contexts as any)];
  }

  return (
    <AudioContext.Provider
      value={{
        assets: {},
      }}
    >
      <Wrapper>
        {!props.condensed && contexts?.length > 0 && (
          <>
            <Contexts>
              <Tab.Tabs
                active={shownContextIndex}
                onClick={(value) => {
                  setShownContextIndex(value);
                }}
              >
                {contexts.map((c, idx) => {
                  return (
                    <Tab.Item key={c.id} value={idx.toString()}>
                      {c.name}
                    </Tab.Item>
                  );
                })}
              </Tab.Tabs>
              {shownContextIndex !== undefined &&
                contexts[shownContextIndex] && (
                  <Context data={contexts[shownContextIndex]} />
                )}
            </Contexts>
            <Divider>
              <div></div>
            </Divider>
          </>
        )}
        <Main>
          {props.condensed && contexts?.length > 0 && (
            <>
              <Button
                title="Show Passages"
                onClick={() => setShowContexts(!showContexts)}
              >
                {showContexts ? "Hide" : "Show"} Passages ({contexts?.length})
              </Button>
              {showContexts && (
                <div style={{ marginTop: "1rem" }}>
                  <Tab.Tabs
                    active={shownContextIndex.toString()}
                    onClick={(value) => {
                      setShownContextIndex(value);
                    }}
                  >
                    {contexts.map((c, idx) => {
                      return (
                        <Tab.Item key={c.id} value={idx.toString()}>
                          {c.name}
                        </Tab.Item>
                      );
                    })}
                  </Tab.Tabs>
                  {shownContextIndex !== undefined &&
                    contexts[shownContextIndex] && (
                      <Context data={contexts[shownContextIndex]} />
                    )}
                </div>
              )}
            </>
          )}
          <div className="item-player-pad">
            <Canvas />
          </div>
        </Main>
      </Wrapper>
    </AudioContext.Provider>
  );
};

export default Question;
